export default __webpack_public_path__ + "static/media/cluster_point.cb58a38c.svg";